import { NumberValue, Schema } from '@coveo/bueno';
import { createSelector } from '@reduxjs/toolkit';
import { stateKey } from '../../../../app/state-key.js';
import { nextPage, previousPage, registerRecommendationsSlotPagination, selectPage, setPageSize, } from '../../../../features/commerce/pagination/pagination-actions.js';
import { paginationReducer as commercePagination } from '../../../../features/commerce/pagination/pagination-slice.js';
import { loadReducerError } from '../../../../utils/errors.js';
import { validateOptions } from '../../../../utils/validate-payload.js';
import { buildController, } from '../../../controller/headless-controller.js';
const optionsSchema = new Schema({
    pageSize: new NumberValue({ min: 1, max: 1000, required: false }),
});
/**
 * @internal
 * Creates a `Pagination` sub-controller instance.
 *
 * @param engine - The headless commerce engine.
 * @param props - The configurable `Pagination` sub-controller properties.
 * @returns A `Pagination` sub-controller instance.
 * */
export function buildCorePagination(engine, props) {
    if (!loadPaginationReducers(engine)) {
        throw loadReducerError;
    }
    const controller = buildController(engine);
    const { dispatch } = engine;
    validateOptions(engine, optionsSchema, props.options, 'buildCorePagination');
    const slotId = props.options?.slotId;
    if (props.options?.pageSize) {
        dispatch(setPageSize({
            slotId,
            pageSize: props.options.pageSize,
        }));
    }
    if (slotId) {
        dispatch(registerRecommendationsSlotPagination({ slotId }));
    }
    const paginationSelector = createSelector((state) => slotId
        ? state.commercePagination.recommendations[slotId]
        : state.commercePagination.principal, ({ perPage, ...rest }) => ({
        pageSize: perPage ?? 0,
        ...rest,
    }));
    return {
        ...controller,
        get state() {
            return paginationSelector(engine[stateKey]);
        },
        selectPage(page) {
            dispatch(selectPage({
                slotId,
                page,
            }));
            dispatch(props.fetchProductsActionCreator());
        },
        nextPage() {
            dispatch(nextPage({ slotId }));
            dispatch(props.fetchProductsActionCreator());
        },
        previousPage() {
            dispatch(previousPage({ slotId }));
            dispatch(props.fetchProductsActionCreator());
        },
        setPageSize(pageSize) {
            dispatch(setPageSize({ slotId, pageSize }));
            dispatch(props.fetchProductsActionCreator());
        },
        fetchMoreProducts() {
            dispatch(props.fetchMoreProductsActionCreator());
        },
    };
}
function loadPaginationReducers(engine) {
    engine.addReducers({
        commercePagination,
    });
    return true;
}
